import React from "react";
import { Alert, Col, Form, Row } from "react-bootstrap";

const ProblemsCompare = () => {
  return (
    <>
      <Row>
        <h4>Compare your problems</h4>
        <Col className="px-0 pb-0">
          <Alert variant="warning" className="px-2 pb-1 mb-0">
            <h5 className="text-center">Your Code</h5>
            <h6 className="fw-bold">Example code:</h6>
            <Form.Control
              as="textarea"
              rows={18}
              readOnly
              className="bg-code"
              placeholder={`<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Document</title>
</head>
<body>
    <h1>Demo example code</h1>
</body>
</html>`}
            />
          </Alert>
        </Col>
        <Col className="px-0 pb-0">
          <Alert variant="success" className="px-2 pb-1 mb-0">
            <h5 className="text-center">Compare with</h5>
            <h6 className="fw-bold">Example code:</h6>
            <Form.Control
              as="textarea"
              rows={18}
              readOnly
              className="bg-ccode"
              placeholder={`<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Document</title>
</head>
<body>
    <h1>Demo example compare code</h1>
</body>
</html>`}
            />
          </Alert>
        </Col>
      </Row>
    </>
  );
};

export default ProblemsCompare;
